import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/pin.vue
var s = {
	name: "DtIconPin",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--pin"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Pin",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M4 .5a1.5 1.5 0 0 0 0 3v1.88a.5.5 0 0 1-.277.447l-.892.451a1.5 1.5 0 0 0-.83 1.342v.88a.5.5 0 0 0 .5.5h3v2a.5.5 0 1 0 1 0V9h3a.5.5 0 0 0 .5-.5v-.88a1.5 1.5 0 0 0-.831-1.342l-.89-.45h-.002A.5.5 0 0 1 8 5.38V3.5a1.5 1.5 0 1 0 0-3H4Zm0 1a.5.5 0 0 0 0 1h.5A.5.5 0 0 1 5 3v2.38a1.5 1.5 0 0 1-.83 1.342l-.892.45A.5.5 0 0 0 3 7.62V8h6v-.38a.5.5 0 0 0-.277-.447L8.72 7.17l-.889-.449a1.5 1.5 0 0 1-.83-1.342V3a.5.5 0 0 1 .5-.5H8a.5.5 0 0 0 0-1H4Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=pin.js.map